import React from 'react';
import { useTranslation } from 'react-i18next';
import './PageName.css';
import PropTypes from 'prop-types';

const PageName = props => {
  const { t } = useTranslation();

  let content;
  switch (props.path) {
    case '':
      content = (
        <>
          <img src={`${process.env.PUBLIC_URL}/assets/images/menuIcon/home.svg`} alt="" />
          <span className="">{t('home')}</span>
        </>
      );
      break;
    case '/design-list':
      content = (
        <>
          <img src={`${process.env.PUBLIC_URL}/assets/images/menuIcon/myTemp.svg`} alt="" />
          <span className="">{t('yourDesigns')}</span>
        </>
      );
      break;
    case '/templates':
      content = (
        <>
          <img src={`${process.env.PUBLIC_URL}/assets/images/menuIcon/temp.svg`} alt="" />
          <span className="">{t('templates')}</span>
        </>
      );
      break;
    case '/subscribe':
      content = (
        <>
          <img src={`${process.env.PUBLIC_URL}/assets/images/menuIcon/subscribe.svg`} alt="" />
          <span className="">{t('subscribe')}</span>
        </>
      );
      break;
    case '/assistant':
      content = (
        <>
          <img src={`${process.env.PUBLIC_URL}/assets/images/menuIcon/support.svg`} alt="" />
          <span className="">{t('smartAssistant')}</span>
        </>
      );
      break;
    case '/support':
      content = (
        <>
          <img src={`${process.env.PUBLIC_URL}/assets/images/menuIcon/support.svg`} alt="" />
          <span className="">{t('support')}</span>
        </>
      );
      break;

    default:
      break;
  }

  return <div className="pageName">{content}</div>;
};

PageName.propTypes = {
  path: PropTypes.string,
};

export default PageName;
